<div class="page-graphs-section">
	<div class="opp-breakdown-section">
		<div class="page-graph-heading-section">
			<img src="assets/events.png" class="page-graph-heading-icon" />
			<span>Opportunities Breakdown</span>
		</div>
		<div class="each-page-graph-content">
			<div id="breakdown-graph"></div>
		</div>
	</div>
	<div class="opp-detail-graph-section">
		<div class="each-page-graph-block">
			<div class="page-graph-heading-section">
				<img src="assets/events.png" class="page-graph-heading-icon" />
				<span>Rule Based Triggers Breakdown</span>
				<div class="section-heading-tooltip-block">
					<img src="assets/info-black.png" />
					<div class="section-heading-tooltip-section" style="width: 400px; left: 0; ">
						<div class="module-page-information-section" *ngFor="let section of rule_based_tooltip_section">
							<div class="each-module-page-information-section">
								<p class="each-module-page-information-heading">{{section.name}}</p>
							</div>
							<ng-container *ngIf="section.sub_sections">
								<ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
									<div class="each-module-page-information-sub-section">
										<!-- <p class="each-module-page-information-sub-heading">{{index + 1}}. {{sub_section.name}}:</p> -->
										<!-- <p class="each-module-page-information-sub-content">{{index + 1}}. {{sub_section.value}}</p> -->
										<p class="each-module-page-information-heading">{{index + 1}}. {{sub_section.value}}</p>
									</div>
								</ng-container>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
			<div class="each-page-graph-content">
				<div id="rule-based-breakdown-graph"></div>
			</div>
		</div>
		<div class="each-page-graph-block">
			<div class="page-graph-heading-section">
				<img src="assets/events.png" class="page-graph-heading-icon" />
				<span>AI Triggers Breakdown</span>
				<div class="section-heading-tooltip-block">
					<img src="assets/info-black.png" />
					<div class="section-heading-tooltip-section" style="width: 400px; left: 0;">
						<div class="module-page-information-section" *ngFor="let section of ai_based_tooltip_section">
							<div class="each-module-page-information-section">
								<p class="each-module-page-information-heading">{{section.name}}</p>
							</div>
							<ng-container *ngIf="section.sub_sections">
								<ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
									<div class="each-module-page-information-sub-section">
										<!-- <p class="each-module-page-information-sub-heading">{{index + 1}}. {{sub_section.name}}:</p> -->
										<!-- <p class="each-module-page-information-sub-content">{{index + 1}}. {{sub_section.value}}</p> -->
										<p class="each-module-page-information-heading">{{index + 1}}. {{sub_section.value}}</p>
									</div>
								</ng-container>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
			<div class="each-page-graph-content">
				<div id="ai-triggers-breakdown-graph"></div>
			</div>
		</div>
	</div>
</div>
